import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userState } from '../recoil/authAtom';

interface AdminTeacherRouteProps {
  children: React.ReactNode;
}

const AdminTeacherRoute: React.FC<AdminTeacherRouteProps> = ({ children }) => {
  const user = useRecoilValue(userState);

  const allowedRoles = ['admin', 'teacher'];
  
  if (!user.role || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminTeacherRoute;